import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import DanhSachHoSo from "./DanhSachHoSo";
import ModalUngVien from "./ModelUngVien";
import {
    getAllGioiThieuUngVien,
    XoaGioiThieuUngVien,
    getAllThietLap,
} from "store/slices/tuyenDungSlice";
import MeditechTablePage, { FilterComponent } from "components/table-layout";
import { SystemButtonSource } from "constants";
import { notification, Select, Spin } from "antd";
import { getAllDepartmentBranch } from "store/slices/categorySlice";

const initSearch = {
    startDate: null,
    endDate: null,
    searchText: null,
    trangThai: null,
    donViId: null,
};

const listTrangThai = [
    { value: 1, label: "Chờ tiếp nhận" },
    { value: 2, label: "HS Không đạt yêu cầu" },
    { value: 3, label: "HS Đạt yêu cầu" },
    { value: 4, label: "Đã Trúng tuyển" },
    { value: 5, label: "Không trúng tuyển" },
];

const GioiThieuUngVien = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [visibleModal, setVisibleModal] = useState(location.state?.openModal === true);
    const [maHoSo, setMaHoSo] = useState(null);
    const [viewOnly, setViewOnly] = useState(false);
    const { branchId } = useSelector((state) => state.auth);
    const { allBranchList } = useSelector((state) => state.category);
    const dispatch = useDispatch();
    const { loading, GioiThieuUngVienList } = useSelector(
        (state) => state.tuyenDung
    );

    useEffect(() => {
        reloadData();
        dispatch(getAllThietLap(5));
        dispatch(getAllDepartmentBranch());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, branchId]);

    useEffect(() => {
        if (location.state?.openModal === true) {
            setMaHoSo(null);
            setVisibleModal(true);
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location.state?.openModal, location.pathname, navigate]);

    const searchFormRef = useRef({ ...initSearch });
    const [searchFormData, setSearchFormData] = useState(searchFormRef.current);
    const searchHandle = (dataSearch) => {
        searchFormRef.current = { ...searchFormRef.current, ...dataSearch };
        setSearchFormData({ ...searchFormRef.current });
        reloadData();
    };

    const onRenderSearchView = () => {
        return (
            <FilterComponent
                datasource={searchFormData}
                onSearchImmediate={searchHandle}
                renderInputSearch
                renderDatePicker
            >
                <Select
                    key="trangThai"
                    data-field="trangThai"
                    style={{ width: "100%", minWidth: 200 }}
                    placeholder="Trạng thái"
                    options={listTrangThai}
                    allowClear
                />
                <Select
                    key="donViId"
                    data-field="donViId"
                    style={{ width: "100%", minWidth: 200 }}
                    placeholder="Đơn vị"
                    options={(allBranchList || []).map((m) => ({ value: m.id, label: m.name }))}
                    showSearch
                    filterOption={(input, option) =>
                        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                    }
                    allowClear
                />
            </FilterComponent>
        );
    };

    const reloadData = () => {
        const params = {
            ...searchFormRef.current,
            trangThai: searchFormRef.current.trangThai ?? -1,
        };
        dispatch(getAllGioiThieuUngVien(params));
    };

    const onDeleteHandler = (id) => {
        dispatch(
            XoaGioiThieuUngVien({
                id: id,
                onSuccess: ({ data }) => {
                    if (!data.isOk) {
                        notification.error({
                            message: "Xóa giới thiệu ứng viên",
                            description: data.description,
                        });
                        return;
                    }
                    reloadData();
                },
            })
        );
    };

    const onOpenDetailHandler = (id) => {
        setViewOnly(false);
        setMaHoSo(id);
        setVisibleModal(true);
    };

    const onViewDetailHandler = (id) => {
        setViewOnly(true);
        setMaHoSo(id);
        setVisibleModal(true);
    };

    const getRightButton = (isLocked) => {
        const arr = [];
        if (isLocked) {
            arr.push({
                keyName: SystemButtonSource.addBtn,
                title: "Thêm",
                showMore: false,
            });
        }
        return arr;
    };

    const onRightTopBtnHandler = (key) => {
        switch (key) {
            case SystemButtonSource.addBtn:
                setVisibleModal((prev) => !prev);
                break;
            default:
                break;
        }
    };

    return (
        <>
            <Spin tip="Đang tải..." spinning={loading}>
                <MeditechTablePage
                    tableTitle="GIỚI THIỆU ỨNG VIÊN"
                    btnHeaderRightSource={getRightButton(true)}
                    btnHeaderRightSourceHandle={onRightTopBtnHandler}
                    onRenderSearchView={onRenderSearchView}
                >
                    <DanhSachHoSo
                        HoSoUngVienList={GioiThieuUngVienList}
                        loading={loading}
                        onDelete={onDeleteHandler}
                        onOpenDetail={onOpenDetailHandler}
                        onViewDetail={onViewDetailHandler}
                        reloadData={reloadData}
                    />
                </MeditechTablePage>
            </Spin>

            <ModalUngVien
                visibleModal={visibleModal}
                setVisibleModal={setVisibleModal}
                maHoSo={maHoSo}
                setMaHoSo={setMaHoSo}
                loading={loading}
                reloadData={reloadData}
                viewOnly={viewOnly}
                setViewOnly={setViewOnly}
            />
        </>
    );
};
export default GioiThieuUngVien;
